/**
 * Store module for managing message selection state
 * Used for multi-message forwarding feature
 */

const state = {
  selectedMessageIds: [],
  isSelectionMode: false,
  conversationId: null,
};

export const getters = {
  getSelectedMessageIds: $state => $state.selectedMessageIds,
  isSelectionMode: $state => $state.isSelectionMode,
  getSelectedCount: $state => $state.selectedMessageIds.length,
  isMessageSelected: $state => messageId =>
    $state.selectedMessageIds.includes(messageId),
  getConversationId: $state => $state.conversationId,
};

export const actions = {
  toggleMessageSelection({ commit, state: $state }, messageId) {
    if ($state.selectedMessageIds.includes(messageId)) {
      commit('REMOVE_MESSAGE_FROM_SELECTION', messageId);
    } else {
      commit('ADD_MESSAGE_TO_SELECTION', messageId);
    }
  },

  selectMessage({ commit }, messageId) {
    commit('ADD_MESSAGE_TO_SELECTION', messageId);
  },

  deselectMessage({ commit }, messageId) {
    commit('REMOVE_MESSAGE_FROM_SELECTION', messageId);
  },

  enterSelectionMode({ commit }, { conversationId, initialMessageId = null }) {
    commit('SET_SELECTION_MODE', true);
    commit('SET_CONVERSATION_ID', conversationId);
    commit('CLEAR_SELECTION');
    if (initialMessageId) {
      commit('ADD_MESSAGE_TO_SELECTION', initialMessageId);
    }
  },

  exitSelectionMode({ commit }) {
    commit('SET_SELECTION_MODE', false);
    commit('CLEAR_SELECTION');
    commit('SET_CONVERSATION_ID', null);
  },

  clearSelection({ commit }) {
    commit('CLEAR_SELECTION');
  },

  selectMultipleMessages({ commit }, messageIds) {
    messageIds.forEach(id => {
      commit('ADD_MESSAGE_TO_SELECTION', id);
    });
  },
};

export const mutations = {
  ADD_MESSAGE_TO_SELECTION($state, messageId) {
    if (!$state.selectedMessageIds.includes(messageId)) {
      $state.selectedMessageIds.push(messageId);
    }
  },

  REMOVE_MESSAGE_FROM_SELECTION($state, messageId) {
    $state.selectedMessageIds = $state.selectedMessageIds.filter(
      id => id !== messageId
    );
  },

  SET_SELECTION_MODE($state, value) {
    $state.isSelectionMode = value;
  },

  SET_CONVERSATION_ID($state, conversationId) {
    $state.conversationId = conversationId;
  },

  CLEAR_SELECTION($state) {
    $state.selectedMessageIds = [];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
